module.exports = __webpack_public_path__ + "staticcomp/img/content_3.c5158c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/5/content_3.jpg
// module id = 5nsO
// module chunks = 39